export default (function () {
  return {
    // there's no SMB impression event, so don't log impressions
    logImpression: false,
    text: 'Apply Now'
  };
});